import { process } from './process-env';

const env = process.env;

export const environment = {
  production: false,
  siteUrl: (env.SITE_URL_DEV || env.SITE_URL || 'https://milkhouse-dev.pages.dev').replace(/\/$/, ''),
  cartWorkerUrl:
    env.CART_WORKER_URL_DEV ||
    env.CART_WORKER_URL ||
    'https://milkhouse-cart-worker-dev.opavlovskyi.workers.dev',
  contentful: {
    spaceId: env.CONTENTFUL_SPACE_ID,
    environment: env.CONTENTFUL_ENVIRONMENT || 'development',
    deliveryToken: env.CONTENTFUL_DELIVERY_TOKEN,
    previewToken: env.CONTENTFUL_PREVIEW_TOKEN,
    host: 'cdn.contentful.com',
  },
};
